import React, { useState, useEffect, useMemo } from "react";
import PdfViewerAction from '../../actions/pdf-viewer/pdf-viewer.action'
import { ButtonHLPure, DialogPdf } from '../../pures';
import "./consult-negotiation-pdf.css";

const ConsultNegotationPDFView = (props) => {

    const {
        url
    } = props

    const [urlPdf, setUrlPdf] = useState(url)
    const [blobAWS, setBlobAWS] = useState(url);

    useEffect(() => {
        setUrlPdf(url)
        setBlobAWS(url)
    }, [url])

    const pdf = useMemo(() => <PdfViewerAction url={urlPdf} isExtended={false} isSSRActive={false} />, [urlPdf])

    return (
        <div>
            <div className='consultNegotationPDFView-documentPDF-container'>
                {pdf}
            </div>
            <div className="consultNegotationPDFView-documentPDF-pdf-btn">
                <DialogPdf blobUrl={blobAWS} />
            </div>
        </div>
    )
}

export { ConsultNegotationPDFView as default }